import React, { useRef, useState, useEffect } from 'react';
import { BASE_API } from '../../api/Globals';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import { Dropdown } from 'primereact/dropdown';
import { helpHttp } from "../../helpers/helpHttp";
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { storage } from '../../helpers/storage';


import Menu from '../../components/sturtural/Menu';
import { Password } from 'primereact/password';

const initialForm = {
    usuario: "",
    nombre: "",
    tipo_usuario: null,
    tienda: "",
    password: "",
    status: true
}

const validationsFrom = (form) => {

    let errors = {};
    let regexName = /^[A-Za-zÑñÁáÉéÍíÓóÚúÜü\s]+$/;
    //let regexEmail = /^(\w+[/./-]?){1,}@[a-z]+[/.]\w{2,}$/;
    let regexEmail = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
    //let regexComments = /^.{1,255}$/;
    let regexDigitos = /^.{1,10}$/;
    let regexNumbers = /^([0-9])*$/;

    if (!form.nombre.trim()) {
        errors.nombre = "El Campo (Nombre completo) es requerido";
    }

    if (!form.usuario.trim()) {
        errors.usuario = "El Campo (Nombre de usuario) es requerido";
    }

    if (!form.tipo_usuario) {
        errors.tipo_usuario = "El Campo (Tipo de usuario) es requerido";
    }

    if(form.tipo_usuario === 13){
        if(!form.tienda){
            errors.tienda = "El Campo (Sede) es requerido"
        }
    }

    // if(![1, 5].includes(parseInt(form.tipo_usuario.code))) {
    //     if(!form.tienda) {
    //         errors.tienda = "El Campo (Tienda) es requerido";
    //     }
    // } 

    if (!form.password) {
        errors.password = "El Campo (Contraseña) es requerido";
    }

    return errors;
}

const CreateUser = () => {
    const navigate = useNavigate();

    const [form, setForm] = useState(initialForm);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [response, setResponse] = useState(null);
    const [getTipoUsuario, setTiposUsuario] = useState(null);
    const [getTiendas, setTiendas] = useState(null);
    const [getInputTienda, setInputTienda] = useState(false);

    const [aviso, setAviso] = useState(false);
    const [message, setMessage] = useState(null);

    const perfil = storage.get('perfilid');

    useEffect(() => {
        if (![1, 5, 9, 10, 11, 12, 19].includes(parseInt(perfil))) {
            return navigate('/login');
        }
    }, [perfil]);

    let url = `${BASE_API}Dinamico/ConsultaDinamica`;

    useEffect(() => {
        helpHttp().post(url, {
            body: {
                sp: "spdTipoUsuariosObtener",
                tipo: 0,
                parametros: [
                    { idTipoUsuario: perfil }
                ]
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.ITEMS !== null) {

                if (res.ITEMS.length > 0) {
                    setTiposUsuario(res.ITEMS);
                } else {
                    setTiposUsuario(null);
                }
                setLoading(false);
            }

        });
    }, [url]);

    let url2 = `${BASE_API}Usuarios/EjecutarTiendas`;

    useEffect(() => {
        setLoading(true);
        helpHttp().post(url2, {
            body: {
                "opcion": "O",
                "IdTienda": 0,
                "Tienda": "",
                "Activo": true
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            let jsonTiendas = res.ITEMS;

            if (jsonTiendas.length > 0) {

                setTiendas(jsonTiendas);
            } else {
                setTiendas(null);
            }
            setLoading(false);
        });
    }, [url2]);

    const toast = useRef(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        console.log(name, value)

        if (name === 'tipo_usuario') {
            if (![1, 5].includes(parseInt(value))) {
                setInputTienda(true);
            } else {
                setInputTienda(false);
            }
            setErrors(validationsFrom({
                ...form,
                [name]: value,
            }))
        }

        setForm({
            ...form,
            [name]: value,
        });
    };

    const handleBlur = (e) => {
        handleChange(e);
        setErrors(validationsFrom(form));
    };

    const handleResponse = () => {
        setResponse(false);
        showToast('error', 'Error de captcha', 'Favor de aceptar el captcha');
    }

    const showToast = (severity, summary, detail) => {
        toast.current.show({
            severity: severity,
            summary: summary,
            detail: detail,
            life: 5000
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        setErrors(validationsFrom(form));

        if (Object.keys(errors).length === 0) {

            const arrUser = {
                opcion: "A",
                IdUsuario: 0,
                Usuario: form.usuario,
                Nombre: form.nombre,
                Password: form.password,
                Activo: true,
                IdTipoUsuario: form.tipo_usuario,
                TipoPerfil: form.tipo_usuario,
                IdTienda: ([1, 5].includes(parseInt(form.tipo_usuario)) ? 0 : parseInt(form.tienda))
            };

            setLoading(true);

            helpHttp().post(`${BASE_API}Usuarios/EjecutarUsuarios`, {
                body: arrUser,
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                },
            })
                .then((res) => {

                    if (res.ITEMS.length === 0) {
                        showToast('success', 'Mensaje:', 'Usuario registrado correctamente');
                        return navigate('/configuracion/usuarios');
                    } else {
                        setMessage(JSON.parse(res.ITEMS[0].mensaje)[0].mensaje);
                        setAviso(true);
                    }
                });

            setLoading(false);
        } else {
            showToast('warn', 'Mensaje:', 'Favor de llenar los campos requeridos.');
            return;
        }
    };

    const handlerRedirect = () => {
        setMessage(null);
        setAviso(false)
    }

    const basicDialogFooter = <Button type="button" label="Aceptar" onClick={() => handlerRedirect(false)} icon="pi pi-check" className="p-button" />;

    return (
        <>
            <div className="grid">
                <Toast ref={toast} />

                <Menu link='filtro' />

                <form onSubmit={handleSubmit} className="col-12" autoComplete="none">
                    <div className="card">
                        <div className="col-12 lg:flex md:flex sm:flex">
                            <div className='col-12 lg:col-6 md:col-6 sm:col-6'>
                                <h4>Nuevo usuario</h4>
                            </div>
                            
                            <div className='col-12 lg:col-6 md:col-6 sm:col-6 text-right'>
                                <label style={{color: 'red'}}>* Campos obligatorios</label> 
                            </div>
                        </div>
                        

                        <div className="p-fluid formgrid grid">
                            <div className="field col-12 lg:col-3 md:col-6 ">
                                <label htmlFor="usuario"><label style={{color: 'red'}}>*</label> Nombre de usuario:</label>
                                <InputText autoComplete="none" id="usuario" name="usuario" type="text" placeholder='Usuario para inicio de sesión' value={form.usuario} onChange={handleChange} onBlur={handleBlur} className={errors.usuario && 'p-invalid'} autoFocus />
                                {errors.usuario && <small className="p-error">{errors.usuario}</small>}
                            </div>
                            <div className="field col-12 lg:col-3 md:col-6 ">
                                <label htmlFor="nombre"><label style={{color: 'red'}}>*</label> Nombre completo:</label>
                                <InputText id="nombre" name="nombre" type="text" placeholder='Nombre completo' value={form.nombre} onChange={handleChange} onBlur={handleBlur} className={errors.nombre && 'p-invalid'} />
                                {errors.nombre && <small className="p-error">{errors.nombre}</small>}
                            </div>
                            <div className="field col-12 lg:col-2 md:col-4">
                                <label htmlFor="tipo_usuario"><label style={{color: 'red'}}>*</label> Tipo de usuario:</label>
                                <Dropdown id="tipo_usuario" name="tipo_usuario" value={form.tipo_usuario} options={getTipoUsuario} optionLabel="name" optionValue='code' placeholder="Selecciona" onChange={(e) => { handleChange(e) }} ></Dropdown>
                                {errors.tipo_usuario && <small className="p-error">{errors.tipo_usuario}</small>}
                            </div>


                            {(form.tipo_usuario == 13 &&
                            <div className="field col-12 lg:col-2 md:col-4" id="div-tienda">
                                <label htmlFor="tienda"><label style={{color: 'red'}}>*</label> Sede:</label>
                                <select name="tienda" id="tienda" placeholder="Selecciona" className={`form-select p-inputtext p-component`} onChange={handleChange} >
                                    <option value="">Selecciona</option>
                                    {getTiendas && getTiendas.map((el) => <option value={el.IdTienda} key={el.IdTienda}>{el.Tienda}</option>)}
                                </select>
                                {errors.tienda && <small className="p-error">{errors.tienda}</small>}
                            </div>
                            )}

                            <div className="field col-12 lg:col-2 md:col-4">
                                <label htmlFor="password"><label style={{color: 'red'}}>*</label> Contraseña:</label>
                                <Password toggleMask feedback={false} autoComplete="new-password" placeholder='Contraseña' id="password" name="password" type="password" value={form.password} onChange={handleChange} onBlur={handleBlur} className={errors.password && 'p-invalid'} />
                                {errors.password && <small className="p-error">{errors.password}</small>}
                            </div>

                        </div>
                        <div className="p-dialog-footer text-right" style={{ marginTop: '15px', paddingTop: '15px' }}>
                            <Button type='button' label="Cancelar" icon='pi pi-times' className="p-button-outlined mr-2 mb-2" onClick={() => navigate('/configuracion/usuarios')} />
                            <Button disabled={loading} icon={(loading ? 'pi pi-spin pi-spinner' : 'pi pi-check')} type='submit' label="Guardar" className="p-component mr-2 mb-2" />
                        </div>
                    </div>
                </form>
            </div>

            <Dialog header="AVISO" closable={false} draggable={false} visible={aviso} onHide={() => handlerRedirect} style={{ width: '400px' }} modal className="p-fluid" footer={basicDialogFooter}>
                <p>{message && message}</p>
            </Dialog>
        </>
    )
}

export default CreateUser;